/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import { Pannellum } from 'pannellum-react';
import Section from '../components/section';
// import Gallery from 'react-photo-gallery';
// import Image from './Image';

// import './spinner.scss';

const ImageItem = ({ photo }) => {
  const url = `https://www.instagram.com/p/${photo.shortcode}/`;
  return (
    <a href={url} rel="noopener noreferrer" target="_blank" className="gallery-link">
      <LazyLoad>
        <img src={photo.src} alt="" style={{ width: '100%' }} />
      </LazyLoad>
    </a>
  );
};

class InatgramTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = { photos: [] };
    this.URL = 'https://www.instagram.com/explore/tags/dom_yalta_portfolio/?__a=1';
  }

  componentDidMount() {
    fetch(this.URL)
      .then(response => response.json())
      .then(({ graphql: { hashtag: { edge_hashtag_to_media: { edges } } } }) => {
        const photos = edges
          .filter(({ is_video }) => !is_video)
          .slice(0, 12)
          .map(({ node: { thumbnail_resources, shortcode } }) => ({
            src: thumbnail_resources[2].src,
            shortcode,
          }));
        this.setState({ photos });
      });
  }

  render() {
    const { photos } = this.state;
    return (
      <Section title="Общий вид">
        <div className="rooms-list">
          <div className="row row--wrap">
            <div className="col-xs-12 col-md-12 wow fadeInUp" style={{ padding: 0 }}>
              {typeof window !== 'undefined' && Pannellum && (
                <Pannellum
                  width="100%"
                  image="/tour/pool.jpeg"
                  pitch={0}
                  yaw={180}
                  hfov={110}
                  autoLoad
                  showZoomCtrl
                  autoRotate={-5}
                />
              )}
            </div>
          </div>
          <div className="row row--wrap">
            {photos.map(photo => (
              <div
                key={photo.shortcode}
                className="col-xs-12 col-md-4 wow fadeInUp"
                style={{ padding: 0 }}
              >
                <ImageItem photo={photo} />
              </div>
            ))}
          </div>
          <div className="row row--wrap">
            <div className="col-xs-12 col-md-12 wow fadeInUp" style={{ padding: 0 }}>
              {typeof window !== 'undefined' && Pannellum && (
                <Pannellum
                  width="100%"
                  image="/tour/terrace.jpeg"
                  pitch={0}
                  yaw={180}
                  hfov={110}
                  autoLoad
                  showZoomCtrl
                  autoRotate={-5}
                />
              )}
            </div>
          </div>
          <div className="row row--wrap">
            <div className="col-xs-12 col-md-12 wow fadeInUp" style={{ padding: 0 }}>
              <div id="yandex_rtb_R-A-599273-1"></div>
              <script
                id="gatsby-plugin-yandex-direct"
                key={`gatsby-plugin-yandex-direct`}
                dangerouslySetInnerHTML={{
                  __html: `(function(w, d, n, s, t) {
                      w[n] = w[n] || [];
                      w[n].push(function() {
                        Ya.Context.AdvManager.render({
                          blockId: "R-A-599273-1",
                          renderTo: "yandex_rtb_R-A-599273-1",
                          async: true
                        });
                      });
                      t = d.getElementsByTagName("script")[0];
                      s = d.createElement("script");
                      s.type = "text/javascript";
                      s.src = "//an.yandex.ru/system/context.js";
                      s.async = true;
                      t.parentNode.insertBefore(s, t);
                    })(this, this.document, "yandexContextAsyncCallbacks");`
                }}
              />
            </div>
          </div>
        </div>
      </Section>
    );
  }
}

ImageItem.propTypes = {
  photo: PropTypes.shape({
    shortcode: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
  }).isRequired,
};

export default InatgramTemplate;
